import S from 's-js';

/**
 * Return a signal that mirrors the provided signal except that it won't report a new value until the given
 * delay has passed since the last update to the provided signal.
 * @param signal The signal to debounce
 * @param delayMs Optional. The delay after which to report changes. Defaults to 300 ms.
 * @param eq Optional. A comparison function that will be passed to `S.value` internally.
 */
export function debounceSignal<T>(signal : () => T, delayMs = 300, eq? : (a : T, b : T) => boolean) {
    const debounced = S.value(S.sample(signal), eq);
    S.on(signal, () => {
        const timeoutId = window.setTimeout(() => debounced(signal()), delayMs);
        S.cleanup(() => window.clearTimeout(timeoutId));
    }, undefined, true);
    return () => debounced();
}



// WEBPACK FOOTER //
// ./lib/debounceSignal.ts